import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { BodyText, ButtonText } from '@panel/commons/lib/typography';
import { getNeutralColors } from '@panel/commons/lib/theme';
import { usePublisherUnifiedPanel } from '../../hooks/usePublisherUnifiedPanel';

const BannerWrapper = styled.div`
  text-align: center;
  height: 100%;
  width: 100%;
`;

const Title = styled(BodyText).attrs({ size: 200 })`
  color: ${getNeutralColors('white')};
  display: block;
  white-space: break-spaces;
`;

const TextLink = styled(ButtonText).attrs({ size: 200 })`
  cursor: pointer;
  text-decoration: underline;
`;

const PublisherUnifiedBanner = ({ setRedir, autologinFetchOneTimeOnly }) => {
  const { t } = useTranslation();
  const { getAutologin } = usePublisherUnifiedPanel();

  const handleClick = () => {
    getAutologin({ modal: '' });
    setRedir(true);
  };

  useEffect(() => {
    if (!autologinFetchOneTimeOnly) {
      handleClick();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autologinFetchOneTimeOnly]);

  return (
    <BannerWrapper>
      <Title size={200}>
        <TextLink onClick={() => handleClick()}>{t('panel.header.banner.cta')}</TextLink>
        {t('panel.header.banner.text')}
      </Title>
    </BannerWrapper>
  );
};

export { PublisherUnifiedBanner };
